import { useEffect, useState } from 'react'
import { buildSetupEntryUrl, resolveSetupEntryIntentFromLocation, type SetupEntryIntent } from './onboardingEntryRouting'

const currentSetupEntryIntent = (): SetupEntryIntent => {
  if (typeof window === 'undefined') return 'welcome'
  return resolveSetupEntryIntentFromLocation({
    pathname: window.location.pathname,
    search: window.location.search,
  })
}

export const useSetupEntryNavigation = () => {
  const [setupEntryIntent, setSetupEntryIntent] = useState<SetupEntryIntent>(currentSetupEntryIntent)

  useEffect(() => {
    if (typeof window === 'undefined') return
    const syncIntent = () => {
      setSetupEntryIntent(currentSetupEntryIntent())
    }
    window.addEventListener('popstate', syncIntent)
    return () => {
      window.removeEventListener('popstate', syncIntent)
    }
  }, [])

  const navigateSetupEntry = (intent: 'setup' | 'login') => {
    if (typeof window === 'undefined') return
    const nextUrl = buildSetupEntryUrl({
      intent,
      pathname: window.location.pathname,
      search: window.location.search,
      origin: window.location.origin,
    })
    window.history.replaceState({}, '', nextUrl)
    setSetupEntryIntent(intent)
  }

  return { setupEntryIntent, navigateSetupEntry }
}
